<template>
  <div>
    <div class="content-box">
      <div class="os-tabs-w">
        <div class="os-tabs-controls os-tabs-complex text-right">
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <span aria-expanded="true" class="nav-link active"><span class="tab-label"
                  style="font-size: 16px">Usuario:</span><span v-if="current && current.usuario"
                  style="font-size: 16px"><b>{{ current.usuario }}</b></span></span>
            </li>
            <li class="nav-item">
              <span aria-expanded="true" class="nav-link active"><span class="tab-label" style="font-size: 16px">Fecha
                  Creación:</span><span v-if="current && current.fecha_creacion" style="font-size: 16px"><b>{{
                    current.fecha_creacion | moment("DD/MM/YYYY") }}</b></span></span>
            </li>
            <li v-if="current.fecha_entrega && current.estado == 'B'" class="nav-item ml-auto text-md-center">
                <span aria-expanded="true" class="nav-link active">
                  <span class="tab-label" style="font-size: 16px">
                </span>
                
                <span style="font-size: 16px">
                  Vence: 
                  <b>
                    {{ formatTimeAgo(current.fecha_entrega) }}
                  </b>
                </span>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="row">       
        <div class="col-lg-12">        
          <div class="element-wrapper">           
            <div class="element-box">            
              <router-link v-if="!backToReception" class="btn btn-sm btn-outline-dark" :to="{ name: 'compras-ordencompra' }">
                <i class="fas fa-angle-double-left"></i>
                Atras
              </router-link>
              <button v-else class="btn btn-sm btn-outline-dark" @click="$router.go(-1)">
                <i class="fas fa-angle-double-left"></i>
                Volver a Recepcion
              </button>           
              &nbsp;   
              <h5 class="form-header">
                Orden de Compra&nbsp;
                <span v-if="current.numero != null">#{{ current.numero }}</span>
                &nbsp;
                <div class="badge" :class="{
                  'badge-success': current.estado == 'A',
                  'badge-warning': current.estado == 'B',
                  'badge-dark': current.estado == 'D',
                  'badge-danger': current.estado == '9',
                }">
                  <i class="os-icon os-icon-ui-09"></i>
                  <span v-if="current.estado_str">
                    {{ current.estado_str }} 
                  </span>
                  <span v-if="!current.estado_str">En Proceso</span>
                </div>
                &nbsp;&nbsp;
                <div class="badge mr-2" :class="{'badge-success': current.Es_urgente === false, 'badge-danger': current.Es_urgente === true}">
                  <i class="fas fa-flag"></i>
                  <span v-if="current.Es_urgente === false" >&nbsp;Normal</span>
                  <span v-if="current.Es_urgente === true">&nbsp;Urgente</span>
                </div>

                <span class="badge badge-danger" v-if="current.vencida">
                  Vencida
                </span>
               

                <div class="st-meta float-right">
                  <div class="element-actions">
                    <button @click="refreshCurrent()" class="btn btn-link">
                      Actualizar Info. <i class="fas fa-sync"></i>
                    </button>
                    <button type="button" class="btn btn-outline-success" @click="abrirModalLogOC()">
                      <i class="fas fa-history"></i>Log de modificaciones
                    </button>
                    <button type="button" :disabled="current.estado == 'A'" class="btn btn-outline-secondary"
                      @click="imprimir">
                      <i class="fa fa-print"></i>
                      Imprimir
                    </button>
                    &nbsp;
                    <div class="btn-group">
                      <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline-secondary dropdown-toggle"
                        data-toggle="dropdown" type="button">
                        <i class="fa fa-cogs"></i>
                        Acciones
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <button class="dropdown-item" :class="{ disabled: !(current.estado == 'B') }" @click="abrir"
                          href="#" type="button">
                          <i class="fa fa-unlock"></i>
                          Abrir Operación
                        </button>
                        <button class="dropdown-item" @click="cerrar" :disabled="!(current.estado == 'A')" href="#"
                          type="button">
                          <i class="fa fa-lock"></i>
                          Cerrar Operación
                        </button>
                        <button class="dropdown-item" @click="anular" :disabled="!(current.estado != '9')" href="#">
                          <i class="fa fa-archive"></i>
                          Anular Operación
                        </button>
                        <button class="dropdown-item" @click="DarBajaModal()"
                          :disabled="current.estado == '9' || current.estado == 'A' || current.estado == 'C'" href="#">
                          <i class="fas fa-power-off"></i>
                          Dar de Baja Orden Compra 
                        </button>
                        <button class="dropdown-item" @click="marcar_como_urgente" :disabled="current.Es_urgente" href="#">
                          <i class="fa fa-flag"></i>
                          Marcar como urgente
                        </button>                        
                        <!-- <button
                          class="dropdown-item"
                          :disabled="current.estado != 'B'"
                          href="#"
                          @click="generar_entrada_compra"
                        >
                          <i class="fa fa-paper-plane"></i>
                          Generar Entrada por Compra
                        </button> -->
                        <div class="dropdown-divider"></div>     
                      </div>
                    </div>
                  </div>
                </div>
              </h5>
              <div class="btn btn-success" data-toggle="modal" data-target="#mostrarOrdenesAgendadas" v-if="estado_oc_en_agenda.agregado_agenda==true" style="width:350px">
                <i class="fas fa-edit"></i>
                &nbsp; &nbsp;
                <span>Agregado en agenda</span>
                &nbsp; &nbsp;
                <span class="fas fa-eye"></span>
              </div>

              <small v-if="current.errors && current.errors.detail" class="form-text text-danger">{{ current.errors.detail
              }}</small>
              <div class="row mt-5">
                <div class="col-sm-3">
                  <TiendaSelectComponent :current="current" :disabled="current.id != null" />
                </div>
                <div class="col-sm-6">
                  <ProveedoresSelectComponent :current="current" :disabled="current.estado != 'A'" />
                </div>
                <div class="col-sm-3">
                  <label>Fecha entrega</label>
                  <input type="date" class="form-control" v-model="current.fecha_entrega"
                    :disabled="current.estado != 'A'" />
                </div>
                <div class="col-12">
                  <label>Referencia</label>
                  <input type="text" class="form-control form-control-sm" v-model="current.referencia" :disabled="true" />
                </div>
                <div class="col-12">
                  <label>Observaciones</label>
                  <textarea class="form-control form-control-sm observacionOC" v-model="current.observaciones" :disabled="true"></textarea>
                </div>
                <div class="col-sm-12" v-if="current.cotizacion_e">
                  <CotizacionSelectComponent :current="current" :disabled="current.cotizacion != ''" />
                </div>
              </div>
              <div>
                <br />
                <div class="row">
                  <div class="col-4">
                    <button type="button" class="btn btn-md btn-outline-dark btn-block" @click="showModalAddDetail"
                      v-if="current.estado == 'A' && current.id">
                      Agregar Producto &nbsp;
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                  <div class="col-4">
                    <button type="button" class="btn btn-md btn-outline-dark btn-block" @click="showModalAddDetailLista"
                      v-if="current.estado == 'A' && current.id">
                      Agregar Producto Por Lista Proveedor &nbsp;
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                  <div class="col-4">
                    <button type="button" class="btn btn-md btn-outline-dark btn-block" @click="showModalAddExcel"
                      v-if="current.estado == 'A' && current.id">
                      Cargar Archivo de Excel &nbsp;
                      <i class="fas fa-cloud-upload-alt"></i>
                    </button>
                  </div>
                </div>
                <br />
                <button class="btn btn-sm btn-dark btn-block" v-if="current.estado == 'B'"
                  @click="AbrirModalDistribuirOC()" type="button">
                  Distribución orden de compra <i class="fa fa-cubes"></i>
                </button>
              </div>
              <div class="text-right">
                <small><i style="color: #4ab618" class="fas fa-asterisk"> NORMAL</i></small>
                &nbsp;&nbsp;&nbsp;
                <small><i style="color: #00a2ff" class="fas fa-asterisk">
                    BONIFICACIÓN</i></small>
                &nbsp;&nbsp;&nbsp;
                <small><i style="color: #000000" class="fas fa-asterisk"> PROMOCIÓN</i></small>
              </div>
              <br />
              <div class="invoice-table" v-if="current.id != null">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th class="text-left">Estatus</th>
                      <th>Producto</th>
                      <th class="text-right" style="width: 80px !important">Cantidad</th>
                      <th class="text-center" style="width: 10px !important">UM</th>
                      <th v-if="current.permite_cambiar_precio == true" class="text-right" style="width: 110px">
                        Precio Compra
                      </th>
                      <th v-if="current.permite_cambiar_precio == true" class="text-right" style="width: 50px !important">
                        % Desc
                      </th>
                      <th v-if="current.permite_cambiar_precio == true" class="text-right"
                        style="width: 100px !important">
                        Costo
                      </th>
                      <th class="text-center" style="width: 100px !important">Precio Negociado</th>
                      <th class="text-center" style="width: 10px !important">Impuesto</th>
                      <th class="text-center" style="width: 100px !important">Total</th>
                      <th class="text-center" v-if="current.estado == 'B'">Ingresada</th>
                      <th class="text-center" v-if="current.estado == 'B'">Pendiente</th>
                      <th style="width: 50px !important" class="text-center">Tipo</th>
                      <th style="width: 5px !important" class="text-center" v-if="current.estado == 'A'"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(detalle, indexDetalle) in current.ordencomprad_set" :key="indexDetalle" v-if="detalle.estado !== '9'">
                      <td class="text-left">
                        <i v-if="detalle.estado == 'B'" class="fas fa-circle" style="color: #FF8F00;'"></i>
                        <i v-if="detalle.estado == 'A'" class="fas fa-circle" style="color: #4ab618;'"></i>
                        <i v-if="detalle.estado == '9'" class="fas fa-circle" style="color: #FF0000;'"></i>
                      </td>
                      <td>
                        <div class="value">{{ detalle.producto_obj.sku }}</div>
                        <span class="sub-value">
                          <small>{{ detalle.producto_obj.nombre }}</small>
                        </span>
                      </td>
                      <td class="text-right">
                        <small><span v-if="current.estado != 'A'">{{
                          detalle.cantidad_um
                        }}</span>
                          <div class="input-group input-group-sm" v-if="current.estado == 'A'">
                            <div class="input-group-prepend"></div>
                            <input @change="calcularDetalle(indexDetalle)"
                              :disabled="current.estado == 'B' || detalle.estado == '9'" class="form-control text-right"
                              v-model="detalle.cantidad_um" placeholder="Precio" type="text" />
                            <div class="input-group-append"></div>
                          </div>
                        </small>
                      </td>
                      <td style="width: 5px" class="text-center" v-if="detalle.unidad_medida">
                        <small>{{ detalle.unidad_medida.nombre }}</small>
                      </td>
                      <td style="width: 5px" class="text-center" v-if="!detalle.unidad_medida">
                        UNIDAD
                      </td>
                      <td v-if="current.permite_cambiar_precio == true" class="text-right">
                        <small><span v-if="current.estado != 'A'">{{
                          detalle.precio_compra
                        }}</span>
                          <div class="input-group input-group-sm" v-if="current.estado == 'A'">
                            <div class="input-group-prepend">
                              <div class="input-group-text">Q</div>
                            </div>
                            <input @change="calcularDetalle(indexDetalle)"
                              :disabled="current.estado == 'B' || detalle.estado == '9'" class="form-control text-right"
                              v-model="detalle.precio_compra" placeholder="Precio" type="text" />
                          </div>
                        </small>
                      </td>
                      <td v-if="current.permite_cambiar_precio == true" class="text-right" style="width: 120px">
                        <small><span v-if="current.estado != 'A'">
                            {{ detalle.porc_descuento }}
                          </span>
                          <div class="input-group input-group-sm" v-if="current.estado == 'A'">
                            <input @change="calcularPorsec(indexDetalle)"
                              :disabled="current.estado == 'B' || detalle.estado == '9'" class="form-control text-right"
                              v-model="detalle.porc_descuento" placeholder="Precio" type="text" />
                            <div class="input-group-prepend">
                              <div class="input-group-text">%</div>
                            </div>
                          </div>
                        </small>
                      </td>
                      <td v-if="current.permite_cambiar_precio == true" class="text-right" style="width: 120px">
                        <small><span v-if="current.estado != 'A'">
                            {{ detalle.costo }}
                          </span>
                          <div class="input-group input-group-sm" v-if="current.estado == 'A'">
                            <div class="input-group-prepend">
                              <div class="input-group-text">Q</div>
                            </div>
                            <input @change="calcularDetalle(indexDetalle)"
                              :disabled="current.estado == 'B' || detalle.estado == '9'" class="form-control text-right"
                              v-model="detalle.costo" placeholder="Precio" type="text" />
                            <div class="input-group-prepend"></div>
                          </div>
                        </small>
                      </td>
                      <td class="text-center">
                        <small>{{ detalle.precio_negociado }}</small>
                      </td>
                      <td class="text-center">
                        <small>{{ detalle.tipo_impuesto }}</small>
                      </td>
                      <td class="text-center">
                        <small>Q {{ detalle.total_linea }}</small>
                      </td>
                      <td class="text-success text-center" v-if="current.estado == 'B'">
                        <strong>+{{ detalle.ingresada }}</strong>
                      </td>
                      <td style="color: #ff0a03" class="text-center" v-if="current.estado == 'B'">
                        <strong>{{ detalle.pendiente }}</strong>
                      </td>
                      <td class="text-center">
                        <i v-if="detalle.tipo == 'B'" class="fas fa-asterisk" style="color: #00A2FF;'"></i>
                        <i v-if="detalle.tipo == 'A'" class="fas fa-asterisk" style="color: #4ab618;'"></i>
                        <i v-if="detalle.tipo == 'P'" class="fas fa-asterisk" style="color: #000000;'"></i>
                      </td>
                      <td style="width: 10px" class="text-center row-actions" v-if="current.estado == 'A'">
                        <button class="btn btn-sm btn-danger mr-1" type="button" @click="deleteDetalle(detalle)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="3">Total Detalle Orden de Compra</td>
                      <td class="text-right" colspan="5">
                        Q {{ current.valor_total_ordencompra }}
                      </td>
                      <td colspan="5"></td>
                    </tr>
                  </tfoot>
                </table>

                <!-------------------- END - Basic Table -------------------->
              </div>
              <div class="form-buttons-w">
                <button class="btn btn-md btn-success" v-if="current.estado == 'A'" @click="guardar" type="button">
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="onboarding-modal modal fade animated" id="modalAddDetailReqCompra" role="dialog"
      tabindex="-1">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content text-center">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span class="close-label">Cerrar</span><span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding-content with-gradient" style="padding: 35px 50px 0px">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label v-bind:class="{
                    'text-danger':
                      currentDetalle.errors && currentDetalle.errors.length > 0,
                  }"></label>
                  <ProductoSelectComponentV2 @onChangeProducto="onChangeProducto" :current="currentDetalle">
                  </ProductoSelectComponentV2>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <ul class="nav nav-pills mt-2 mb-3">
                    <li class="nav-item col-4">
                      <a style="font-size: 12px" v-bind:style="currentDetalle.tipo == 'A'
                        ? 'background-color: #4AB618; color: #FFFFFF;'
                        : 'color: #929292;'
                        " class="nav-link" @click="setA" data-toggle="tab"
                        :class="{ active: currentDetalle.tipo == 'A' }" href="#">NORMAL</a>
                    </li>
                    <li class="nav-item col-4">
                      <a v-bind:style="currentDetalle.tipo == 'B'
                        ? 'background-color: #00A2FF; color: #FFFFFF;'
                        : 'color: #929292;'
                        " style="font-size: 12px" class="nav-link" @click="setB" data-toggle="tab"
                        :class="{ active: currentDetalle.tipo == 'B' }" href="#">BONIFICACIÓN</a>
                    </li>
                    <li class="nav-item col-4">
                      <a v-bind:style="currentDetalle.tipo == 'P'
                        ? 'background-color: #000000  ; color: #FFFFFF;'
                        : 'color: #929292;'
                        " style="font-size: 12px" class="nav-link" @click="setP" data-toggle="tab"
                        :class="{ active: currentDetalle.tipo == 'P' }" href="#">PROMOCIÓN</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label v-bind:class="{
                    'text-danger':
                      currentDetalle.errors && currentDetalle.errors.length > 0,
                  }"></label>
                  <UnidadMedidaCompraSelectComponent @onchangeselect="changeUnidadMedida" :current="currentDetalle">
                  </UnidadMedidaCompraSelectComponent>
                  <small v-if="unidades_medidas" class="form-text text-danger">{{
                    unidades_medidas
                  }}</small>
                </div>
              </div>
              <div class="col-6 modal-header">
                <a @change="calcularDetalle" class="el-tablo centered trend-in-corner">
                  <div class="label">Cantidad</div>
                  <div>
                    <input class="form-control value" style="
                        font-size: 32px;
                        text-align: center;
                        width: 100%;
                        height: 50px;
                      " placeholder="Cantidad" v-model="currentDetalle.cantidad_um" />
                  </div>
                </a>
              </div>
              <div class="col-6 modal-header">
                <a @change="calcularDetalle" class="el-tablo centered trend-in-corner">
                  <div class="label">Costo</div>
                  <div>
                    <input v-if="current.permite_cambiar_precio == true" :disabled="currentDetalle.tipo != 'A'"
                      class="form-control value" style="text-align: center; width: 100%; height: 50px" placeholder="Q"
                      v-model="currentDetalle.costo" />
                  </div>
                  <small class="form-text text-success">Precio con IVA</small>
                  <small v-if="currentDetalle.errors && currentDetalle.errors.costo" class="form-text text-danger">{{
                    currentDetalle.errors.costo[0] }}</small>
                </a>
              </div>
              <div class="col-6 modal-header">
                <a @change="calcularPorsec" class="el-tablo centered trend-in-corner">
                  <div class="label">% descuento</div>
                  <div>
                    <input v-if="current.permite_cambiar_precio == true" :disabled="currentDetalle.tipo != 'A'"
                      class="form-control value" style="text-align: center; height: 50px; width: 100%" placeholder="%"
                      v-model="currentDetalle.porc_descuento" />
                  </div>
                </a>
              </div>
              <div class="col-6 modal-header">
                <a @change="calcularDetalle" class="el-tablo centered trend-in-corner">
                  <div class="label">Precio Compra</div>
                  <div>
                    <input v-if="current.permite_cambiar_precio == true" :disabled="currentDetalle.tipo != 'A'"
                      class="form-control value" style="text-align: center; height: 50px; width: 100%" placeholder="Q"
                      v-model="currentDetalle.precio_compra" />
                  </div>
                  <small class="form-text text-success">Precio con IVA</small>
                  <small v-if="currentDetalle.errors && currentDetalle.errors.precio_compra"
                    class="form-text text-danger">{{ currentDetalle.errors.precio_compra[0] }}</small>
                </a>
              </div>
              &nbsp;
              <div class="project-info col-12">
                <div class="row align-items-center">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-3">
                        <div class="el-tablo highlight text-center">
                          <div class="label">Pendiente OC</div>
                          <div class="value">
                            <h4 v-bind:class="{
                              'text-danger': currentDetalle.ordenes_pendientes > 0,
                            }" style="color: rgb(58, 180, 29)">
                              {{ currentDetalle.ordenes_pendientes }}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div v-if="current.permite_cambiar_precio == true" class="col-3">
                        <div class="el-tablo highlight text-center">
                          <div class="label">Costo Unit</div>
                          <div class="value">
                            <h4 style="color: rgb(58, 180, 29)">
                              {{ currentDetalle.costo_unitario }}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div v-if="current.permite_cambiar_precio == true" class="col-3">
                        <div class="el-tablo highlight text-center">
                          <div class="label">Precio sin IVA</div>
                          <div class="value">
                            <h4 style="color: rgb(58, 180, 29)">
                              {{ currentDetalle.precio_compra_sin_imp }}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="el-tablo highlight text-center">
                          <div class="label">Total</div>
                          <div class="value">
                            <h4 style="color: rgb(58, 180, 29)">
                              {{ currentDetalle.total_um }}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="el-tablo text-center">
                      <div class="label">Por Solicitar Automáticamente / Sugerido</div>
                      <div v-if="sugerido.length > 0">
                        <div style="overflow-y: scroll; max-height: 700px" class="table-responsive">
                          <!-------------------- Tabla de REsultados -------------------->
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th>UM</th>
                                <th>Minimo</th>
                                <th>Máximo</th>
                                <th>Existencia</th>
                                <th>Requerido a Cedis</th>
                                <th>Pedido</th>
                                <th style="width: 5%">
                                  <small style="color: green">¡SUGERIDO!</small>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="detalle in sugerido" v-bind:key="detalle.id">
                                <td class="text-center">
                                  {{ detalle.unidad_medida_nombre }}
                                </td>
                                <td>
                                  {{ detalle.minimo }}
                                </td>
                                <td>
                                  {{ detalle.maximo }}
                                </td>
                                <td>
                                  <span class="text-right text-success" :class="{
                                    'text-danger': detalle.existencia <= detalle.minimo,
                                    'text-info': detalle.existencia > detalle.maximo,
                                  }">
                                    {{ detalle.existencia }}
                                  </span>
                                </td>
                                <td>
                                  {{ detalle.cantidad_abierta }}
                                </td>
                                <td>
                                  {{ detalle.cantidad_abierta_oc }}
                                </td>
                                <td class="text-center">
                                  {{ detalle.sugerido }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <!-------------------- END - Basic Table -------------------->
                        </div>
                      </div>
                      <div class="value" v-if="sugerido.length == 0">
                        <h4 class="text-warning">Sin sugerido</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="agregaDetalle" ref="cerrarModal" type="button">
              Agregar
              <i class="fas fa-save"></i>
            </button>
            <button class="btn btn-info" @click="changeUnidadMedida" ref="cerrarModal" type="button">
              Volver a Cargar Precios
              <i class="fas fa-history"></i>
            </button>
            <button class="btn btn-secondary" ref="cerrarModal" data-dismiss="modal" type="button">
              Cerrar
              <i class="fas fa-door-open"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="onboarding-modal modal fade animated" id="modalCargarExcel" role="dialog" tabindex="-1"
      data-controls-modal="your_div_id" data-backdrop="static" data-keyboard="false" href="#">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content text-center">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span class="close-label">Cerrar</span><span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding-content with-gradient" style="padding: 15px; padding-left: 35px"></div>
          <h5 class="modal-title text-success">Cargar Datos .XLSX</h5>
          <br />
          <div class="row col-12">
            <div class="col-2 text-left">
              <img
                src="data:image/png;base64,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"
                alt="" style="width: 50px; margin-right: 10px" />
            </div>
            <div class="col-10 text-left">
              <i class="fas fa-info" style="color: green"></i> &nbsp; El archivo a subir
              debe ser en formato .XLSX con las espeficicaciones dadas. Sino tiene el
              formato lo puede descargar:<button class="btn btn-link btn-sm font-weight-bold" @click="generarExcel">
                Aquí <i class="fas fa-link"></i>
              </button>
            </div>
          </div>
          &nbsp;
          <input class="form-control form-control-md" style="background-color: #ace5b2" type="file" @input="UpFileExcel"
            ref="fileInput" />
          <div class="modal-footer">
            <span class="text text-danger" v-if="error">
              {{ error }}
            </span>
            <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">
              Cerrar <i class="fa fa-door-open"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="onboarding-modal modal fade animated" id="modaldetalleProveedor" role="dialog"
      tabindex="-1" data-controls-modal="your_div_id" data-backdrop="static" data-keyboard="false" href="#">
      <div class="modal-dialog modal-lg" role="document" style="max-width: 100%">
        <div class="modal-content text-center" style="width: 100%; max-width: 90%">
          <button aria-label="Close" class="close" @click="CerrarModal()" type="button">
            <span class="close-label">Cerrar</span><span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding-content with-gradient" style="padding: 15px; padding-left: 35px">
            <h5 class="modal-title text-success">
              Productos por Proveedor y Subcategoría
            </h5>
            <div class="row">
              <div class="col-6 text-left">
                <h6>
                  Tienda:
                  <span v-if="current && current.tienda_obj" class="text-success">{{
                    current.tienda_obj.nombre
                  }}</span>
                  &nbsp;||&nbsp; Proveedor:
                  <span class="text-success">{{ current.proveedor.codigo }} - {{ current.proveedor.nombre
                  }}</span>&nbsp;||&nbsp; OC:
                  <span class="text-success"># {{ current.numero }}</span>
                  <hr />
                </h6>
              </div>
              <div class="col-6">
                <SubCategoriaSelectComponent @change="refreshListaProductos()"
                  title="Para cargar los productos por favor seleccione una subcategoría" :current="current" />
              </div>
            </div>

            <div class="row">
              <!-------------------- END - Controles arriba de tabla-------------------->
              <div style="overflow-y: scroll; max-height: 700px" class="table-responsive">
                <!-------------------- Tabla de REsultados -------------------->
                <table class="table table-striped">
                  <thead style="
                      position: -webkit-sticky;
                      position: sticky;
                      top: 0;
                      z-index: 10;
                      background: #fff;
                    ">
                    <tr>
                      <th>Producto</th>
                      <th>UM</th>
                      <th>Minimo</th>
                      <th>Máximo</th>
                      <th>Existencia</th>
                      <th>Requerido a Cedis</th>
                      <th>Pedido</th>
                      <th style="width: 5%">
                        <small style="color: green">¡SUGERIDO!</small>
                        <br />
                        Sugerido
                      </th>
                      <th style="width: 8%">Cantidad UM</th>
                      <th style="width: 5%">Tipo</th>
                      <th style="width: 130px">Precio Compra</th>
                      <th style="width: 100px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(detalle, index) in productosE" :key="index">
                      <td class="text-left">
                        <span class="font-weight-bold" style="color: green">{{
                          detalle.producto
                        }}</span>
                        - {{ detalle.nombre }}
                      </td>
                      <td class="text-center">
                        {{ detalle.unidad_medida_nombre }}
                      </td>
                      <td>
                        {{ detalle.minimo }}
                      </td>
                      <td>
                        {{ detalle.maximo }}
                      </td>
                      <td>
                        <span class="text-right text-success" :class="{
                          'text-danger': detalle.existencia <= detalle.minimo,
                          'text-info': detalle.existencia > detalle.maximo,
                        }">
                          {{ detalle.existencia }}
                        </span>
                      </td>
                      <td>
                        {{ detalle.cantidad_abierta }}
                      </td>
                      <td>
                        {{ detalle.cantidad_abierta_oc }}
                      </td>
                      <td class="text-center">
                        {{ detalle.sugerido }}
                      </td>
                      <td class="text-right">
                        <small>
                          <div class="input-group input-group-sm">
                            <div class="input-group-prepend"></div>
                            <input class="form-control text-right" v-model="detalle.cantidad_um" style="width: 50px"
                              placeholder="Precio" type="text" />
                          </div>
                        </small>
                      </td>
                      <td>
                        <small>
                          <div class="input-group input-group-sm">
                            <div class="input-group-prepend"></div>
                            <select class="form-control text-right" v-model="detalle.tipo"
                              style="width: 100px; color: green" placeholder="Precio" type="text">
                              <option style="color: black" value="A">NORMAL</option>
                              <option style="color: black" value="B">BONIFICACIÓN</option>
                              <option style="color: black" value="P">PROMOCION</option>
                            </select>
                          </div>
                        </small>
                      </td>
                      <td class="text-right">
                        <small>
                          <div class="input-group input-group-sm">
                            <div class="input-group-prepend">
                              <div class="input-group-text">Q</div>
                            </div>
                            <input class="form-control text-right" v-model="detalle.precio_compra"
                              style="width: 50px; color: black" placeholder="Precio" type="text" />
                          </div>
                        </small>
                      </td>
                      <td class="text-center">
                        <button @click="agregaDetalleProveedor(detalle, index)" class="btn btn-sm btn-blue">
                          Agregar <i class="fas fa-plus"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-------------------- END - Basic Table -------------------->
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <span class="text text-danger" v-if="error">
              {{ error }}
            </span>
            <button class="btn btn-secondary" @click="CerrarModal()">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="onboarding-modal modal fade animated" id="modalMostrarExcel" role="dialog"
      tabindex="-1" data-controls-modal="your_div_id" data-backdrop="static" data-keyboard="false" href="#">
      <div class="modal-dialog modal-lg" role="document" style="max-width: 100%">
        <div class="modal-content text-center" style="width: 100%; max-width: 70%">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span class="close-label">Cerrar</span><span class="os-icon os-icon-close"></span>
          </button>
          <br />
          <br />
          <div class="onboarding-content with-gradient" style="padding: 15px; padding-left: 35px">
            <div class="table-responsive" style="overflow-y: scroll; max-height: 500px">
              <!-------------------- Tabla de REsultados -------------------->
              <table class="table table-striped table-lightborder">
                <thead>
                  <tr>
                    <th class="text-center">SKU</th>
                    <th class="text-center">Tipo OC</th>
                    <th class="text-center">Unidad por fardo</th>
                    <th class="text-center">Cantidad UM</th>
                    <th class="text-center">Precio de Compra</th>
                    <th class="text-center">Total de Linea</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="det in datos_xlsx" v-bind:key="det.id">
                    <td class="text-center">
                      <input style="height: 35px; width: 100px" type="text"
                        class="form-control-sm form-control text-center" v-model="det.producto" />
                    </td>
                    <td class="text-center">
                      <select class="form-control form-control-sm" style="height: 35px; width: 180px" v-model="det.tipo">
                        <option value="A">NORMAL</option>
                        <option value="B">BONIFICACIÓN</option>
                        <option value="P">PROMOCIÓN</option>
                      </select>
                    </td>
                    <td class="text-center">
                      <div class="input-group input-group-sm" style="height: 35px; width: 100px">
                        <div class="input-group-prepend">
                          <div class="input-group-text"></div>
                        </div>
                        <input placeholder="Precio" type="text" v-model="det.unidades_x_fardo"
                          class="form-control text-right" style="width: 50px; color: black" />
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="input-group input-group-sm" style="height: 35px; width: 100px">
                        <div class="input-group-prepend">
                          <div class="input-group-text"></div>
                        </div>
                        <input placeholder="Precio" type="text" v-model="det.cantidad_um" class="form-control text-right"
                          style="width: 50px; color: black" />
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="input-group input-group-sm" style="height: 35px; width: 100px">
                        <div class="input-group-prepend">
                          <div class="input-group-text">Q</div>
                        </div>
                        <input placeholder="Precio" type="text" v-model="det.precio_compra"
                          class="form-control text-right" style="width: 50px; color: black" />
                      </div>
                    </td>
                    <td class="text-center">
                      {{ (det.precio_compra * det.cantidad_um).toFixed(2) }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-------------------- END - Basic Table -------------------->
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-success" @click="ValidarProductos()">
              <span v-if="validando == false">Listo</span><span v-if="validando == true">Validando Datos</span> &nbsp;
              <i :class="{
                'fas fa-check': validando == false,
                'fas fa-sync fa-spin': validando == true,
              }"></i>
            </button>
            <button class="btn btn-outline-secondary" data-dismiss="modal">
              Cerrar <i class="fas fa-door-open"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div aria-hidden="true" class="onboarding-modal modal fade animated" id="aggNuevoProductos" role="dialog"
      tabindex="-1" data-controls-modal="your_div_id" data-backdrop="static" data-keyboard="false" href="#">
      <div class="modal-dialog modal-lg" style="max-width: 100%" role="document">
        <div class="modal-content" style="width: 100%; max-width: 85%">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span class="close-label">Cerrar</span><span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <h4 class="onboarding-title text-center">
                Se encontraron SKUs desconocidos. <br />
                ¿desea agregar algún nuevo producto?
              </h4>
              <div class="table-responsive" style="overflow-y: scroll; max-height: 400px">
                <!-------------------- Tabla de Resultados -------------------->
                <table class="table table-lightborder">
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 70px">SKU</th>
                      <th class="text-center">Descripcion</th>
                      <th style="width: 120px" class="text-center">Grupo</th>
                      <th style="width: 300px" class="text-center">Categoría</th>
                      <th style="width: 300px" class="text-center">Subcategoría</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="det in productos_no_encontrados" v-bind:key="det.id">
                      <td style="padding: 0px" class="text-center">
                        <input style="
                            font-weight: bold;
                            width: 70px;
                            background-color: #badcaa;
                          " type="text" :disabled="true" class="form-control-sm form-control text-center"
                          v-model="det.sku" />
                      </td>
                      <td style="padding-left: 13px; padding-right: 13px" class="text-center">
                        <input type="text" :disabled="det.agregado == true" class="form-control-sm form-control"
                          v-model="det.nombre" />
                      </td>
                      <td style="padding: 0px">
                        <select style="width: 120px" :disabled="det.agregado == true" class="form-control form-control-sm"
                          autofocus="autofocus" v-model="det.grupo">
                          <option v-for="(c, key) in grupos" :value="c.id" :key="key">
                            {{ c.nombre }}
                          </option>
                        </select>
                      </td>
                      <td>
                        <div class="col-12">
                          <select class="form-control form-control-sm" :disabled="det.agregado == true"
                            v-model="det.categoria" @change="refreshSubCategorias(det.categoria)">
                            <option v-for="(c, key) in categorias" :value="c.codigo" :key="key">
                              {{ c.codigo }} - {{ c.nombre }}
                            </option>
                          </select>
                        </div>
                      </td>
                      <td>
                        <div class="col-12">
                          <select class="form-control form-control-sm" v-model="det.sub_categoria"
                            :disabled="det.agregado == true" @input="$emit('input', $event.target.value)">
                            <option v-for="(c, key) in subcategorias" :value="c.codigo" :key="key">
                              {{ c.codigo }} - {{ c.nombre }}
                            </option>
                          </select>
                        </div>
                      </td>
                      <td class="text-center">
                        <i v-if="det.agregado == false" @click="guardarNuevoProducto(det)"
                          style="font-size: 20px; width: 25px; color: #41ae0e" class="far fa-save"
                          onmouseover="this.style.color='#1d5801'" onmouseout="this.style.color='#41ae0e'"></i>
                        <i v-if="det.agregado == true" style="font-size: 20px; width: 25px; color: #41ae0e"
                          class="fas fa-check fa-fade"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-------------------- END - Basic Table -------------------->
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-success" @click="SaveDataExcel()">
              <span v-if="cargando == false">Guardar</span><span v-if="cargando == true">En proceso de carga</span> &nbsp;
              <i :class="{
                'fas fa-check': cargando == false,
                'fas fa-sync fa-spin': cargando == true,
              }"></i>
            </button>
            <button class="btn btn-outline-secondary" data-dismiss="modal">
              Cerrar <i class="fas fa-door-open"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <MotivoBajaComponent v-if="datosListos" :tipoMotivos="tipoMotivos" :idOrdenCompra ="$route.params.id" @refresh-method="refreshCurrent" :current = "current" />

    <ModalDistribucionOcComponent @refreshCurrent="refreshCurrent()" :dataTabla="dataTabla" :current="current" />
    <div v-if="current.id">
      <LogModalComponent modulo="compras" transac="orden_compra_e" :id="current.id" />
    </div>
    
    <div class="modal fade" id="mostrarOrdenesAgendadas" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"> 
              Ordenes de compra agendadas
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times</span>
            </button>
          </div>
          <div class="modal-body">
            <template v-for="reg in ordenes_existentes_agenda">
              <div class="card shadow-sm mb-3 ">
                <div class="row">
                  <div class="card-body col-8 ">
                    <h5 class="card-title">Evento de agenda: {{ reg.agenda_obj.id }}</h5>
                    <h5 class="card-text text-muted mt-3">Fecha: {{ formatearFecha(reg.agenda_obj.fecha_a) }}</h5>
                    <h5 class="card-text text-muted">Tienda: {{ reg.agenda_obj.tienda_obj.codigo }} -- {{ reg.agenda_obj.tienda_obj.nombre }} </h5>                  
                    <h5 class="card-text text-muted">Proveedor: {{ reg.agenda_obj.proveedor_obj.id }} -- {{ reg.agenda_obj.proveedor_obj.nombre }}</h5>
                    <h5 class="card-text text-muted">Tipo: {{ reg.agenda_obj.tipo_display }} </h5>
                    <h5 class="card-text text-muted">Estado de evento: {{ reg.agenda_obj.estado_display }}</h5>  
                  </div>
                  <div class="col-4 text-center align-middle">   
                    <br>
                    <br>  
                    <div v-if="reg.agenda_obj.estado_display=='En Proceso'">
                      <i class="fa fa-hourglass-half text-primary" style="font-size: 6rem" ></i>                      
                    </div>             
                    <div v-if="reg.agenda_obj.estado_display=='Agendado'">
                      <i class="fa fa-edit text-info" style="font-size: 6rem" ></i>                      
                    </div>     
                    <div v-if="reg.agenda_obj.estado_display==='Finalizado'">
                      <i class="fa fa-check text-success" style="font-size: 6rem" ></i>                      
                    </div>   
                    <div v-if="reg.agenda_obj.estado_display==='Cancelado'">
                      <i class="fa fa-ban text-warning" style="font-size: 6rem" ></i>                      
                    </div> 
                        
                </div>
                  
                </div>
                
              </div>
            </template>  
          </div>
          <div class="modal-footer">            
            <button type="button" class="btn btn-secondary" data-dismiss="modal">CERRAR</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import * as XLSX from "xlsx";
import _ from "lodash";
import ProductosService from "@/services/catalogos/ProductosService";
import OrdenCompraService from "@/services/compras/OrdenCompraService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import CategoriaSelectComponent from "@/components/commons/CategoriaSelectComponent ";
import CotizacionSelectComponent from "@/components/commons/CotizacionSelectComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import DynamicService from "@/services/commons/DynamicService";
import ProductoUnidadMedidaSelectComponent from "@/components/commons/ProductoUnidadMedidaSelectComponent";
import UnidadMedidaCompraSelectComponent from "@/components/commons/UnidadMedidaCompraSelectComponent";
import { mapGetters } from "vuex";
import SubCategoriaSelectComponent from "@/components/commons/SubCategoriaSelectComponent ";
import ModalDistribucionOcComponent from "@/components/compras/ordencompra/ModalDistribucionOcComponent";
import LogModalComponent from "@/components/commons/LogModalComponent";
import moment from 'moment';
import MotivoBajaComponent from "@/components/compras/ordencompra/MotivoBajaComponent";
import 'moment/locale/es';
moment.locale('es');

export default {
  components: {
    TiendaSelectComponent,
    ProveedoresSelectComponent,
    CategoriaSelectComponent,
    CotizacionSelectComponent,
    ProductoSelectComponentV2,
    ProductoUnidadMedidaSelectComponent,
    UnidadMedidaCompraSelectComponent,
    SubCategoriaSelectComponent,
    ModalDistribucionOcComponent,
    LogModalComponent,
    MotivoBajaComponent,
  },
  data() {
    return {
      validando: false,
      unidades_medidas: "",
      cargando: false,
      backToReception: false,
      error: "",
      grupos: [],
      productosE: [],
      current: {
        id: null,
        numero: null,
        estado_str: null,
        tienda: "",
        fecha: "",
        estado: "A",
        errors: [],
        ordencomprad_set: [],
        proveedor: "",
        cotizacion: "",
        referencia: "",
      },
      productos_no_encontrados: "",
      no_permite_requerimiento: "",
      tiendas: [],
      proveedores: [],
      dataTabla: [],
      datos_xlsx: [],
      productos: [],
      options: [],
      currentDetalle: {
        tipo: "A",
        ordenes_pendientes: "",
        costo: 0,
        costo_unitario: "",
        precio_compra_sin_imp: "",
        total_um: "",
        porc_descuento: 0,
        id: null,
        cantidad_um: "",
        unidad_medida: null,
        proveedor: null,
        tienda: "",
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        errors: [],
      },
      sugerido: [],
      ordenes_existentes_agenda:[],      
      estado_oc_en_agenda: {
        mensaje_estado: "",
        control_mensaje: "",
        agregado_agenda:false,
        agenda_obj: "",
      }, 
      tipoMotivos: [],   
      datosListos:false
    };
  },
  computed: {
    ...mapGetters({
      categorias: "catalogos/categorias",
      subcategorias: "catalogos/subcategorias",
    }),
  },
  mounted() {
    let self = this;
    if (this.$route.params.id) {
      self.refreshCurrent();
      self.refreshGrupos();
      self.refreshCategorias();      
      self.verificaOrdenDeCompraEnAgenda({id_orden_compra: this.$route.params.id }); 
     
    }
    self.obtenerListadoMotivosDeBaja();
    this.backToReception = this.$route.query.backToReception == "true" || this.$route.query.backToReception == true;
  },
  methods: {
    formatTimeAgo(date) {
      return moment(date).fromNow();
    },
    guardarNuevoProducto(current) {
      let self = this;
      if (current.subcategoria) {
        current.subcategoria = current.subcategoria.codigo;
      }
      if (current.unidad_medida_solicitud) {
        current.unidad_medida_solicitud = current.unidad_medida_solicitud.id;
      }
      ProductosService.save(current)
        .then((res) => {
          self.productos_no_encontrados.forEach(function (item) {
            if (item.sku === current.sku) {
              item.agregado = true;
            }
          });
          self.agregarProductoTienda(current)
        })
        .catch((error) => {
          if (error.response.data.nombre)
            Notifications.alert.error(
              "El proceso no pudo completarse correctamente",
              "Nombre: " + error.response.data.nombre[0]
            );
          if (error.response.data.detail)
            Notifications.alert.error(
              "El proceso no pudo completarse correctamente",
              error.response.data.detail
            );
          if (error.response.data.detail)
            Notifications.alert.error(
              "El proceso no pudo completarse correctamente",
              error.response.data.detail
            );
        });
    },
    agregarProductoTienda(params) {
      params.producto = params.sku
      params.tienda = this.current.tienda
      params.minimo = 0
      params.maximo = 0
      params.activo = true
      params.permitir_compras = true
      params.permitir_ventas = true
      params.sol_auto = false
      params.compra_local = false
      DynamicService.save("cat", "producto-tienda", params)
        .then(() => {
          this.agregarProductoProveedor(params)
        })
        .catch((error) => {
          alert("error, producto_tienda")
        });
    },
    agregarProductoProveedor(params) {
      let self = this;
      params.proveedor = self.current.proveedor.codigo
      DynamicService.save("cat", "producto-proveedor", params)
        .then((response) => {
          Notifications.toast.success("Guardar producto", "Realizado correctamente");
        })
        .catch((error) => {
          alert("error, producto_proveedor")
        });
    },
    refreshCategorias() {
      let self = this;
      self.$store.dispatch("catalogos/categorias", {
        activa: true,
        categoria: self.current.categoria,
        quitar_paginacion: true,
      });
    },
    refreshSubCategorias(categoria) {
      let self = this;
      self.$store.dispatch("catalogos/subcategorias", {
        activa: true,
        categoria: categoria,
        quitar_paginacion: true,
      });
    },
    ValidarProductos() {
      let self = this;
      self.validando = true;
      DynamicService.postAction(
        "compras",
        "orden_compra_e",
        self.current.id,
        "validar_productos_en_bd",
        self.datos_xlsx
      )
        .then((response) => {
          self.validando = false;
          self.productos_no_encontrados = response.data.skus_no_encontrados;
          self.no_permite_requerimiento = response.data.no_permite_requerimiento;

          if (self.no_permite_requerimiento.length != 0) {
            let productos = self.no_permite_requerimiento
              .map(producto => producto.nombre)
              .join('\n');
            self.datos_xlsx = self.datos_xlsx.filter(itemXLSX => {
              return !self.no_permite_requerimiento.some(itemNoPermitido => itemNoPermitido.sku === itemXLSX.producto);
            });
            Notifications.alert.error(
              "Los Siguientes Productos no aceptan requerimiento manual: ", productos
            );
            if (self.productos_no_encontrados.length == 0) {
              self.SaveDataExcel();
            } else {
              $("#aggNuevoProductos").modal("show");
              $("#modalMostrarExcel").modal("hide");
            }
          } else {
            if (self.productos_no_encontrados.length == 0) {
              self.SaveDataExcel();
            } else {
              $("#aggNuevoProductos").modal("show");
              $("#modalMostrarExcel").modal("hide");
            }
          }
        })
        .catch((error) => {
          self.validando = false
          Notifications.alert.error("Agregar tabla de excel", error.response.data.detail);
        });
    },
    UpFileExcel() {
      const allowedTypes = [
        "application/vnd.ms-excel", // .xls
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" // .xlsx
      ];
      const file = this.$refs.fileInput.files[0];
      if (allowedTypes.includes(file.type)) {
        const reader = new FileReader();
        reader.onload = () => {
          this.parseExcel(reader.result);
        };
        reader.readAsArrayBuffer(file);
      } else {
        this.$refs.fileInput.value = "";
        Notifications.alert.error("Solo se permiten archivos con extensión .XLX o .XLSX");
      }
    },
    parseExcel(fileContent) {
      
        const workbook = XLSX.read(fileContent, { type: "arraybuffer" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const parsedData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const headers = parsedData[0];
        const dataRows = parsedData.slice(1);
        const tiposPermitidos = ["A", "B", "P"];
        let mas_de_2_decimales = false;

        const parsedObjects = dataRows.map((curr, index) => {
          const obj = {};
          let contador = index + 1;
          headers.forEach((header, index) => {
            obj[header] = curr[index];
          });
          obj["id"] = contador;
          obj["tienda"] = this.current.tienda;
          return obj;
        });

        this.datos_xlsx = parsedObjects.filter(
          (obj) => obj.producto && obj.producto.toString().trim() !== ""
        );
        this.datos_xlsx.forEach((item) => {
          if (/^\d+(\.\d{1,2})?$/.test(item.precio_compra) === false) {
            mas_de_2_decimales = true;
          }
          item.producto = item.producto.toUpperCase();
          item.tipo = item.tipo.toUpperCase();
        });
        if (mas_de_2_decimales == true) {
          $("#modalCargarExcel").modal("hide");
          alert("El precio de compra debe tener máximo dos decimales");
          return;
        }
        if (this.datos_xlsx.some((elemento) => !tiposPermitidos.includes(elemento.tipo))) {
          $("#modalCargarExcel").modal("hide");
          alert(
            "Se encontró un tipo de OC no permitido en los datos. corregir eso antes por favor."
          );
          return;
        }
        $("#modalCargarExcel").modal("hide");
        $("#modalMostrarExcel").modal("show");
        this.$refs.fileInput.value = "";
      
      
    },
    SaveDataExcel() {
      let self = this;
      self.cargando = true;
      DynamicService.postAction(
        "compras",
        "orden_compra_e",
        self.current.id,
        "agregar_detalle_x_excel",
        self.datos_xlsx
      )
        .then((response) => {
          self.refreshCurrent();
          self.cargando = false;
          $("#modalMostrarExcel").modal("hide");
          $("#aggNuevoProductos").modal("hide");
        })
        .catch((error) => {
          self.cargando = false;
          Notifications.alert.error("Agregar tabla de excel", error.response.data.detail);
        });
    },
    generarExcel() {
      // Definimos los datos a exportar
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet([
        ["producto", "tipo", "unidades_x_fardo", "cantidad_um", "precio_compra"],
        [
          "SKU de producto",
          "tipo A, B o P A = Normal, B = Bonificacion, P = Promocion",
          "cantidad de unidades del fardo",
          "cantidad de fardos",
          "precio por unidad de medida",
        ],
        ["A02497", "A", 18, 10, 80.5],
      ]);

      // Formato primera fila
      const firstRow = XLSX.utils.decode_range(ws["!ref"]).s.r;
      for (let i = 0; i < 5; i++) {
        const cell = XLSX.utils.encode_cell({ r: firstRow, c: i });
        ws[cell].s = {
          fill: { fgColor: { rgb: "FFFF00" } },
          alignment: { horizontal: "center", vertical: "center" },
          font: { bold: true },
        };
        ws["!cols"] = [
          { width: 15 }, // Ancho de la primera columna
          { width: 49 }, // Ancho de la segunda columna
          { width: 27 }, // Ancho de la tercera columna
          { width: 19 }, // Ancho de la cuarta columna
          { width: 25 }, // Ancho de la quinta columna
        ];
      }

      // Formato filas de abajo
      const secondRow = firstRow + 1;
      for (let i = 0; i < 5; i++) {
        const cell = XLSX.utils.encode_cell({ r: secondRow, c: i });
        ws[cell].s = {
          alignment: { horizontal: "center", vertical: "center" },
        };
      }

      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "oc_cloud.xlsx");
    },
    abrirModalLogOC() {
      $("#modalLog").modal("show");
    },
    agregarDisponibleAdetalle() {
      let self = this;
      for (const d in self.current.ordencomprad_set) {
        self.current.ordencomprad_set[d].cantidad_total =
          self.current.ordencomprad_set[d].cantidad_um;
      }
    },
    AbrirModalDistribuirOC() {
      this.dataTabla = this.current.ordencomprad_set;
      $("#modalDistribucionOC").modal("show");
    },
    CerrarModal() {
      self = this;
      $("#modaldetalleProveedor").modal("hide");
      self.productosE = "";
      this.current.subcategoria = "";
    },
    DarBajaModal() {
      let self = this;        
      if(self.estado_oc_en_agenda.estado_interno ==="Agendado"){
        Notifications.alert.error("Dar de baja", "La orden de compra está agendada, para darla de baja el evento en agenda debe estar FINALIZADO o CANCELADO")
        return;
      }

      this.$nextTick(() =>{      
        $("#modalBajaOrdenCompra").modal("show");
      })
    },
    refreshListaProductos() {
      let self = this;
      DynamicService.getActionList(
        "compras",
        "orden_compra_e",
        "traer_productos_proveedor",
        {
          proveedor: self.current.proveedor.id,
          tienda: self.current.tienda,
          subcategoria: self.current.subcategoria.codigo,
        }
      ).then((response) => {
        self.productosE = response.data;
      });
    },
    refreshSugerido() {
      let self = this;
      DynamicService.getActionList(
        "compras",
        "orden_compra_e",
        "traer_productos_proveedor",
        {
          proveedor: self.current.proveedor.id,
          tienda: self.current.tienda,
          sku: self.currentDetalle.producto.sku,
        }
      ).then((response) => {
        self.sugerido = response.data;
      });
    },
    refreshCalculos() {
      let self = this;
      self.currentDetalle.costo = 0;
      self.currentDetalle.precio_compra = 0;
      self.currentDetalle.porc_descuento = 0;
      self.currentDetalle.precio_compra_sin_imp = 0;
      self.currentDetalle.total_linea = 0;
      self.currentDetalle.total_um = 0;
      self.currentDetalle.costo_unitario = 0;
    },
    setA() {
      let self = this;
      self.currentDetalle.tipo = "A";
    },
    setB() {
      let self = this;
      self.currentDetalle.tipo = "B";
      self.refreshCalculos();
    },
    setP() {
      let self = this;
      self.currentDetalle.tipo = "P";
      self.refreshCalculos();
    },
    calcularDetalle(index = -1) {
      let self = this;
      if (index >= 0) {
        self.refreshDetalleDefault();
        self.currentDetalle = Object.assign(
          self.currentDetalle,
          self.current.ordencomprad_set[index]
        );
        self.currentDetalle.producto = self.currentDetalle.producto_obj;
        self.currentDetalle.unidad_medida = self.currentDetalle.unidad_medida.id;
      }

      if (!self.currentDetalle.cantidad_um) {
        delete self.currentDetalle.cantidad_um;
      }
      if (!self.currentDetalle.porc_descuento) {
        self.currentDetalle.porc_descuento = 0;
      }
      DynamicService.postAction(
        "compras",
        "orden_compra_e",
        self.current.id,
        "calcular_detalle",
        {
          producto: self.currentDetalle.producto.sku,
          cantidad_um: self.currentDetalle.cantidad_um,
          precio_compra: self.currentDetalle.precio_compra,
          costo: self.currentDetalle.costo,
          porc_descuento: self.currentDetalle.porc_descuento,
          unidad_medida: self.currentDetalle.unidad_medida,
          tipo: self.currentDetalle.tipo,
        }
      )
        .then((response) => {
          self.currentDetalle.errors = "";
          self.currentDetalle.costo_unitario = response.data.costo_unitario;
          self.currentDetalle.costo = response.data.costo;
          self.currentDetalle.precio_compra = response.data.precio_compra;
          self.currentDetalle.total_um = response.data.total_um;
          self.currentDetalle.precio_compra_sin_imp = response.data.precio_compra_sin_imp;
          self.currentDetalle.porc_descuento = response.data.porc_descuento;

          if (index >= 0) {
            self.current.ordencomprad_set[index].costo_unitario =
              self.currentDetalle.costo_unitario;
            self.current.ordencomprad_set[index].costo = self.currentDetalle.costo;
            self.current.ordencomprad_set[index].precio_compra =
              self.currentDetalle.precio_compra;
            self.current.ordencomprad_set[index].total_um = self.currentDetalle.total_um;
            self.current.ordencomprad_set[index].total_linea =
              self.currentDetalle.total_um;
            self.current.ordencomprad_set[index].precio_compra_sin_imp =
              self.currentDetalle.precio_compra_sin_imp;
            self.current.ordencomprad_set[index].porc_descuento =
              self.currentDetalle.porc_descuento;
          }
        })
        .catch((error) => {
          self.currentDetalle.errors = error.response.data;
        });
      self.refreshSugerido();
    },
    calcularPorsec(index = -1) {
      let self = this;
      if (index >= 0) {
        self.current.ordencomprad_set[index].precio_compra = 0;
        self.refreshDetalleDefault();
        self.currentDetalle = Object.assign(
          self.currentDetalle,
          self.current.ordencomprad_set[index]
        );
        self.currentDetalle.producto = self.currentDetalle.producto_obj;
      }
      self.currentDetalle.precio_compra = 0;
      self.calcularDetalle(index);
    },

    modificarLineaEnTabla(detalle) {
      let self = this;
      self.currentDetalle = { ...self.currentDetalle, ...detalle };
      self.currentDetalle.producto_obj.unidad_medida = detalle.unidad_medida.id;
      self.refreshUnidadMedida(detalle.producto);
      self.modificarDetalle();
    },
    modificarDetalle() {
      let self = this;
      let detMod = Object.assign({}, self.currentDetalle);
      if (detMod.producto) {
        detMod.producto = detMod.producto_obj.sku;
      }
      detMod.unidad_medida = self.currentDetalle.producto_obj.unidad_medida;

      OrdenCompraService.modificar_detalle(self.current.id, detMod)
        .then((response) => {
          Notifications.alert.success(
            "Orden de Compra",
            "Se ha Modificado la Información."
          );
          self.refreshCurrent();
          self.$refs.cerrarModal.click();
        })
        // "validaciones para los errores de modificacion de detalle cotizaciones a proveedores" //
        .catch((error) => {
          self.current.errors = error.response.data;
          if (error.response.data.detail) {
            Notifications.alert.error(
              "No se ha podido realizar la acción",
              error.response.data.detail
            );
          }
        });
    },
    imprimir() {
      let op = this.$route.params.id.replace(/-/g, "");
      let us = localStorage.getItem("id_usuario");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=compras/ordenes_compra/ordencompra.jrxml&usuario=${us}&id=${op}`
      );
    },
    refreshCurrent() {      
      let self = this;          
      OrdenCompraService.getById(this.$route.params.id).then((response) => {
        self.current = response.data;
        if (self.current.fecha_entrega) {   
          self.current.fecha_entrega = moment(self.current.fecha_entrega).format(
            "YYYY-MM-DD"
          );
        }
        self.current.tienda_obj = response.data.tienda;
        self.current.permite_cambiar_precio =
          response.data.usuario.permite_cambiar_precio;
        self.current.tienda = response.data.tienda.codigo;
        self.current.usuario = response.data.usuario.name;
        self.selectedProveedor = self.current.proveedor;
        self.current.cotizacion = response.data.cotizacion_e;
        self.current.errors = [];
        self.currentDetalle.errors = [];
        self.currentDetalle.cantidad = 0;
        self.agregarDisponibleAdetalle();
      });     
    },
    guardar() {
      let self = this;
      let current = Object.assign({}, self.current);
      current.tienda = self.current.tienda;
      current.proveedor = self.current.proveedor.codigo;
      if (self.current.cotizacion) {
        current.cotizacion_e = self.current.cotizacion.id;
      }
      if (self.current.fecha_entrega) {
        current.fecha_entrega = moment(self.current.fecha_entrega).format(
          "YYYY-MM-DDThh:mm:ss.SS"
        );
      }
      current.fecha = current.fecha;
      if (current.id) {
        OrdenCompraService.modificar_tabla(current.id, current.ordencomprad_set)
          .then((response) => {
            OrdenCompraService.save(current)
              .then((res) => {
                self.refreshCurrent();
                self.refreshDetalleDefault();
                Notifications.alert.success("Modificar Tabla", "Realizado Exitosamente");
              })
              .catch((error) => {
                console.log(error.response.data);
                self.current.errors = error.response.data;
              });
          })
          .catch((error) => {
            console.log(error.response.data);
            self.current.errors = error.response.data;
          });
      } else {
        if (!current.fecha) {
          current.fecha = moment().format("DD/MM/YYYY");
        }
        OrdenCompraService.save(current)
          .then((res) => {
            self.$router.push({
              name: "compras-ordencompra-editar",
              params: { id: res.data.id },
            });
            self.refreshCurrent();
          })
          .catch((error) => {
            console.log(error.response.data);
            self.current.errors = error.response.data;
          })
          .catch((error) => {
            console.log(error.response.data);
            self.current.errors = error.response.data;
          });
      }
    },

    onSearchProducto(search, loading) {
      loading(true);
      this.searchProducto(loading, search, this);
    },

    searchProducto: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      ProductosService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.productos = res.data;
        loading(false);
      });
    }, 350),
    showModalAddDetail() {
      let self = this;
      ProductosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
        $("#modalAddDetailReqCompra").modal();
      });
    },
    showModalAddDetailLista() {
      let self = this;
      $("#modaldetalleProveedor").modal();
    },
    showModalAddExcel() {
      let self = this;
      $("#modalCargarExcel").modal();
    },
    agregaDetalleProveedor(detalle, index) {
      let self = this;
      self.productosE[index].tienda = self.current.tienda;
      DynamicService.postAction(
        "compras",
        "orden_compra_e",
        this.current.id,
        "agregar_detalle_por_proveedor",
        detalle
      )
        .then((response) => {
          Notifications.toast.success(
            "Agregar Detalle por Proveedor",
            "Realizado Exitosamente"
          );
          self.productosE[index].cantidad_um = 0;
          self.productosE[index].tipo = "A";
          self.refreshCurrent();
          this.error = "";
        })
        .catch((error) => {
          console.log(error.response.data);
          this.error = error.response.data;
          if (error.response.data && error.response.data.detail) {
            Notifications.alert.error(
              "Agregar Detalle por Proveedor",
              error.response.data.detail
            );
          } else {
            Notifications.toast.error("", JSON.stringify(error.response.data));
          }
        });
    },
    agregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      if (det.proveedor) {
        det.proveedor = det.proveedor.codigo;
      }
      if (det.producto) {
        det.producto = det.producto.sku;
      }
      if (self.currentDetalle.unidad_medida) {
        det.unidad_medida = self.currentDetalle.unidad_medida;
      }
      det.tienda = self.current.tienda;
      OrdenCompraService.agregar_detalle(self.current.id, det)
        .then((response) => {
          Notifications.alert.success(
            "Orden de Compra",
            "Se ha guardado la Información."
          );
          $("#modalAddDetailReqCompra").modal("hide");
          self.refreshDetalleDefault();
          self.refreshCurrent();
          self.precio_compra = 0;
          if (self.unidades_medidas) {
            delete self.unidades_medidas;
          }
        })
        .catch((error) => {
          console.log(error.response.data);
          self.currentDetalle.errors = error.response.data;
          Notifications.alert.error("Agregar detalle", error.response.data.detail);
        });
    },

    deleteDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Orden de Compra",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          OrdenCompraService.eliminar_detalle(detalle.orden_compra_e, {
            id: detalle.id,
          }).then((response) => {
            Notifications.toast.success(
              "Orden de Compra",
              "Se ha eliminado la Información."
            );
            self.refreshCurrent();
          });
        }
      );
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Orden de Compra",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          OrdenCompraService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Orden de Compra",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Abrir Transaccion", error.response.data.detail);
            });
        }
      );
    },
    marcar_como_urgente() {
       let self = this;

      let user_logged = localStorage.getItem("name");
      let usuario_oc = self.current.usuario;

      if (usuario_oc && user_logged && usuario_oc.trim() === user_logged.trim()) {
         Notifications.alert.confirm(
           "Orden de Compra",
           "Está a punto de marcarla como urgente",
           "Si urgente",
           function () {
             OrdenCompraService.marcar_como_urgente(self.current.id)
               .then((response) => {
                 Notifications.alert.success(
                   "Orden de Compra",
                   "Se ha marcado como urgente, proceder con la recepcion."
                 );
                 self.refreshCurrent();
               })
               .catch((error) => {
                 Notifications.alert.error("Orden Compra Urgente", error.response.data.detail);
               });
           }
         );
      } else {
        Notifications.alert.confirm(
          "Orden de Compra",
          "Está a punto de marcarla como urgente una orden creada por otro usuario",
          "Si urgente",
          function () {
            OrdenCompraService.marcar_como_urgente(self.current.id)
              .then((response) => {
                Notifications.alert.success(
                  "Orden de Compra",
                  "Se ha marcado como urgente, proceder con la recepcion."
                );
                self.refreshCurrent();
              })
              .catch((error) => {
                  Notifications.alert.error("Orden Compra Urgente", error.response.data.detail);
              });
            }
          );
      }
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Orden de Compra",
        "Desea cerrar la transacción?",
        "Si Cerrar",
        function () {
          OrdenCompraService.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Orden de Compra",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Error al cerrar", error.response.data.detail);
            });
        }
      );
    },
    anular() {
      let self = this;

      if(self.estado_oc_en_agenda.estado_interno ==="Agendado"){
        Notifications.alert.error("Anular Transacción", "La Orden de Compra está agregada en Agenda Proveedores, para anular el evento en agenda debe estar FINALIZADO o CANCELADO")
        return;
      }



      Notifications.alert.confirm(
        "Orden de Compra",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          OrdenCompraService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Orden de Compra",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {              
              Notifications.alert.error("Anular Transaccion", error.response.data.detail);
            });
        }
      );
    },
    generar_entrada_compra() {
      let self = this;
      Notifications.alert.confirm(
        "Orden Compra",
        "¿Está seguro de generar una Entrada por compra para esta Orden de Compra?",
        "Si",
        function () {
          OrdenCompraService.generar_entrada_compra(self.current.id)
            .then((response) => {
              let _id = response.data.entrada_por_compra;
              Notifications.alert.confirm(
                "Orden de Compra",
                "Entrada por Compra Generada Exitosamente. ¿Ir a la Entrada por Compra generada?",
                "",
                function () {
                  self.$router.push({
                    name: "inventario-entrada_compra-editar",
                    params: { id: _id },
                  });
                }
              );
            })
            .catch((error) => {
              Notifications.alert.error("Orden de Compra", error.response.data.detail);
            });
        }
      );
    },
    changeUnidadMedida() {
      let self = this;
      self.currentDetalle.precio_compra = 0;
      self.currentDetalle.costo = 0;
      self.currentDetalle.porc_descuento = 0;
      self.currentDetalle.cantidad_um = 1;
      self.calcularDetalle();
      if (self.unidades_medidas) {
        self.unidades_medidas = null;
      }
    },
    refreshUnidadMedida(producto) {
      let self = this;
      DynamicService.getById("cat", "productos", producto.sku).then((res) => {
        if (res.data.unidad_medida_compra_obj) {
          self.currentDetalle.unidad_medida = res.data.unidad_medida_compra_obj.id;
          if (self.unidades_medidas) {
            delete self.unidades_medidas;
          }
        } else {
          self.unidades_medidas =
            "Producto no tiene asignado unidad medida para compra pero puede seleccionar una de la lista";
          self.currentDetalle.unidad_medida = "";
        }
        self.currentDetalle.precio_compra = 0;
        self.currentDetalle.costo = 0;
        self.currentDetalle.porc_descuento = 0;
        self.currentDetalle.cantidad_um = 1;
        self.calcularDetalle();
      });
    },
    onChangeProducto(producto) {
      let self = this;
      self.refreshUnidadMedida(producto);
      DynamicService.getAction("cat", "productos", producto.sku, "pendiente_oc", {
        tienda: this.current.tienda,
      }).then((response) => {
        this.currentDetalle.ordenes_pendientes = response.data.pendiente_orden_compra;
      });
    },
    refreshDetalleDefault() {
      let self = this;
      self.currentDetalle = {
        tipo: "A",
        cantidad: 0,
        precio_compra: 0,
        costo: 0,
        porc_descuento: 0,
        cantidad_um: 0,
        unidad_medida: null,
        proveedor: null,
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        errors: [],
      };
    },
    refreshGrupos() {
      let self = this;
      DynamicService.fetch("cat", "grupo-producto", {
        quitar_paginacion: true,
      }).then((res) => {
        self.grupos = res.data;
      });
    },

    /*Verifica si la orden de compra esta asignada a un evento de agenda,
    esto para habilitar o deshabilitar opción Dar De Baja orden de compra*/
    verificaOrdenDeCompraEnAgenda(params){     
      let self = this;       
      DynamicService.getActionList("wms", "agenda-proveedores", "existe_orden_compra_en_agenda_proveedor", params) 
      .then((response)=>{                   
        // self.estado_oc_en_agenda = response.data;  
        self.ordenes_existentes_agenda = response.data;       
        self.estado_oc_en_agenda.agregado_agenda =true 
        self.estadosInternos()    
      }).catch((error) =>{             
        if(error.response && error.response.status === 404){               
          self.estado_oc_en_agenda.mensaje_estado = ""; 
          self.estado_oc_en_agenda.agregado_agenda =false            
        }
       })   
      return self.estado_oc_en_agenda.agregado_agenda;
    }, 
    estadosInternos(){
      /*
      *En este metodo se le dara un estado interno a los eventos de agenda 
      en donde hay ordenes de compra agregadas, para manejar si se puede
      o no se puede dejar que el usuario anule o de de baja la orden de 
      compra. Se puede anular o dar de baja a una OC, solo mientras 
      no este agregada en ningún evento de agenda, o todos los eventos
      de agenda donde está agregada esten Finalizados o Cancelados*/      
      let self=this;      
      let estado_evento = ""
      let estadoFinal = 'Finalizado'
      //Revisa los estados de OC agregados a agenda     
      for(let obj of self.ordenes_existentes_agenda){   
        estado_evento = obj.agenda_obj.estado_display;    
        
        //Se validan estados de la OC en agenda y recepcion    
        if(estado_evento === 'En Proceso' || estado_evento === 'Agendado'){                
          estadoFinal = 'Agendado'         
          break;    
        }               
      }         
      self.estado_oc_en_agenda.estado_interno = estadoFinal      
    },

     /**
     * Método que obtiene el listado de los motivos de baja de una 
     * orden de compra.
     */
     obtenerListadoMotivosDeBaja() {      
      let self = this;     
      DynamicService.getActionList(
        "compras",
        "orden_compra_e",
        "lista_motivos_de_baja"
      ).then((response) => {
        self.tipoMotivos = response.data;      
        self.datosListos=true;   
      })
      .catch((error) => {
        console.error(error);
      });      
    },
    verOrdenesEnAgendaModal(){
      let self= this;
      if(self.ordenes_existentes_agenda.length>1){        
        $("mostrarOrdenesAgendadas").modal("show")
      }else{
        return;
      }
    },
    formatearFecha(fecha){
        let fechaNueva = moment(fecha).format('DD/MM/YYYY');
        return fechaNueva;
    }
  },
};
</script>

<style>
 .observacionOC {
    field-sizing: content;
    min-height: 50px; /* Tamaño por defecto cuando está vacío */
    max-height: 300px; /* Opcional: para que no crezca infinito */
    resize: none;
  }
  .estadoOC{
    border: #28b419 solid 1px;
    background-color: #28b419;    
    border-width:2px;
    width:300px;
    
  }

  .btn-hover{
    background-color: black;
    color: white;
  }

  .btn-hover:hover{
    background-color: #03ddfa
  }
</style>
